import { Button, ButtonProps } from "@mantine/core";
import { IconBrandTiktok } from "@tabler/icons-react";
import { environment } from "../../constants/environment";
import { decodeJWTFromCookie } from "../../utils/jwtUtils";

type TikTokLoginButtonProps = ButtonProps;

function TikTokLoginButton(props: TikTokLoginButtonProps) {
  const email = decodeJWTFromCookie()?.email!;

  return (
    <Button
      component="a"
      href={`${environment.BACKEND_URL}/tiktok/login?email=${email}`}
      leftSection={<IconBrandTiktok size={18} />}
      variant="filled"
      color="dark"
      {...props}
    >
      Link with TikTok
    </Button>
  );
}

export default TikTokLoginButton;
